<template>

    <article class="dd-m-onboarding--presentation__item"
             v-if="item"
             v-bind:class="[{'dd-last' : isLast}, `dd-m-onboarding--presentation__item--${$vnode.key}`]">
        <div class="dd-m-onboarding--presentation__wrapper">
            <header class="dd-m-onboarding--presentation__header">
                <picture>
                    <source :srcset="item.image.desktop" media="(min-width: 1280px)">
                    <source :srcset="item.image.tablet" media="(min-width: 768px)">
                    <img :src="item.image.mobile"
                         :alt="item.title">
                </picture>
            </header>

            <div class="dd-m-onboarding--presentation__content dd-m-text-semibold">
                <h3 class="dd-m-text-bold dd-m-onboarding--presentation__title" v-html="item.title"></h3>

                <p v-html="item.description"></p>

                <footer class="dd-m-onboarding__footer-end">
                    <button type="button" class="dd-m-button dd-m-button--assertive"
                            v-if="!isLast"
                            v-on:click.prevent="next">
                        Next
                    </button>

                    <button type="button" class="dd-m-button dd-m-button--assertive"
                            v-if="isLast"
                            v-on:click.prevent="close">
                        Ok
                    </button>
                </footer>
            </div>
        </div>
    </article>

</template>
<script>
    export default {
        name: 'onboarding-presentation-item',
        props: ['item', 'isLast', 'close', 'next'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/onboarding-presentation-item.vue